import { appEnv } from '../env';
export var polygonValidChainId = appEnv.blockchain.blockchainNetwork === 'mainnet' ? '0x89' : '0x13881';
export var ethValidChainId = appEnv.blockchain.blockchainNetwork === 'mainnet' ? '0x1' : '0xaa36a7';
export function strFloatToTokenQuantity(strFloat, tokens, tokenAddress) {
    if (tokenAddress === appEnv.ctaTokenAddress) {
        var splitted_1 = strFloat.split('.');
        var decimals_1 = splitted_1[1] ? splitted_1[1].slice(0, 18).padEnd(18, '0') : ''.padEnd(18, '0');
        return splitted_1[0] + decimals_1;
    }
    var token = tokens.find(function (item) { return item.token_address === tokenAddress; });
    if (!token)
        throw new Error("Selected token is not defined.");
    var splitted = strFloat.split('.');
    var decimals = splitted[1]
        ? splitted[1].slice(0, Number.parseInt(token.decimals)).padEnd(Number.parseInt(token.decimals), '0')
        : ''.padEnd(Number.parseInt(token.decimals), '0');
    return splitted[0] + decimals;
}
export var sliceAddress = function (address) {
    return "".concat(address.slice(0, 6), "...").concat(address.slice(-4));
};
